const testRegExp = /^\/((?:\\\/|[^/])+)\/([migyu]{0,5})?$/;
/**
 * @param string
 */
export function ensureRegexp(string) {
    if (typeof string !== 'string')
        return string;
    const parts = testRegExp.exec(string);
    if (parts) {
        try {
            return new RegExp(parts[1], parts[2]);
        }
        catch (err) {
            return stringToRegexp(string);
        }
    }
    else {
        return stringToRegexp(string);
    }
}
/**
 * @param string
 * @param flags
 */
function stringToRegexp(string, flags = 'i') {
    return new RegExp(string.replace(/[[\]\\{}()+*?.$^|]/g, (match) => `\\${match}`), flags);
}
//# sourceMappingURL=ensureRegexp.js.map